// The new, pared-down interface (9 October 2026): Projector's format list, a
// format's page, its brief, documents, listening and latest results.
export default {
  liste: {
    titre: 'Formats',
    sousTitre: 'Each format climbs the ladder of proof, from page to screen',
    nouveau: 'New format',
    compte: 'No formats | {n} format | {n} formats',
    tableau: 'Formats',
    col: {
      format: 'Format',
      diffuseur: 'Broadcaster',
      cibles: 'Targets',
      avancement: 'Progress',
      resultat: 'Latest result',
      maj: 'Updated',
    },
    par: 'by {nom}',
    avancementAria: 'Steps tested: {n} of {sur}',
    aucun: 'No formats yet',
    aucunTexte: 'A format starts with its brief, and a title is enough to begin. Its ladder starts with the paper format.',
    pasTeste: 'Not tested yet',
    illisible: 'Not readable yet',
    testEnCours: 'a test in progress',
    sansDiffuseur: 'No destination yet',
    sansCible: 'Not specified',
  },
  marche: {
    brief: 'the audiences to survey',
    format_papier: 'appetite to watch, by target',
    ab: 'the winning version: text, visual or talent',
    dossier: 'the winning variant',
    visuel: 'buy-in to the world',
    casting: 'the talent effect',
    pilote: 'the drop-off points',
    episode: 'retention, the high points, the overall feeling',
    lancement: 'the projected audience share',
    sortie: 'who would watch it on release',
    export: 'appetite, country by country',
  },
  // Confirmations (October 15, 2026).
  confirmer: {
    archiver: {
      titre: 'Archive “{titre}”?',
      texte: 'The format leaves the list and the folder menu, and can no longer be tested. Its studies remain readable.',
    },
  },
  brief: {
    // The brief window's steps (October 15, 2026).
    pas: {
      essentiel: 'The essentials',
      diffusion: 'Broadcast',
      antenne: 'Its slots',
      cibles: 'Targets and format',
      visuel: 'Key art',
    },
    antenne: {
      case: 'Already on air',
      caseAide: 'It is tracked: its slots in the channel’s schedule, every broadcast and its ratings.',
      seulementChaine: 'On-air tracking works on a channel: pick one.',
      choisir: 'Its slots on {chaine}',
      recherche: 'Reading the {chaine} schedule…',
      erreur: 'The schedule could not be read.',
      relire: 'Read the schedule again',
      aucun: 'No slot for “{titre}” in the {chaine} schedule over the last three weeks or the coming week. Check the title as the channel writes it.',
      auMoinsUn: 'Tick at least one slot to track.',
      prochain: 'Next broadcast: {quand}',
      derniere: 'Last ratings: {telespectateurs} viewers ({pda})',
      passes: 'No broadcast in the last three weeks | One broadcast in the last three weeks | {n} broadcasts in the last three weeks',
    },
    creerMaintenant: 'Create now',
    aide: 'A title is enough to begin; fill in the rest when you know it.',
    visuelAide: 'JPEG, PNG or WebP, 12 MB at most.',
  },
  documents: {
    aide: 'What you already know about this format: studies, polls, notes, ratings. Orion uses them to read the format; the panel never reads them. Figures read from them wait for your approval.',
    texte: 'The text',
  },
  ecoute: {
    aide: 'What the format stirs up online: the tone of what is said, the 4Rs, what people write and who is talking.',
    pasDiffuse: 'This format has not aired yet: it can be listened to after its first broadcast.',
    polarite: 'The tone',
    quatreR: 'The 4Rs',
    mentions: 'What they write',
    quiEnParle: 'Who is talking',
    version: 'Listening no. {n} of {le}',
    periode: 'reads {debut} to {fin}',
    periodeTout: 'reads everything said up to {fin}',
    prochaine: 'next listening on {le}',
    versions: '{n} listenings',
    nouvelleEnCours: 'A new listening is running: this one stays on screen until it finishes.',
    consultee: 'You are viewing listening no. {n}, an earlier one.',
    revenir: 'Go back to this listening',
    retourCourante: 'Back to the current listening',
    consulter: 'View',
    courante: 'shown',
    mentionsN: 'no mention | {n} mention | {n} mentions',
    avecTerrain: 'with the field',
    passeEchec: 'returned nothing',
    declencheur: { manuel: 'on demand', apres_prime: 'after a prime', planifie: 'scheduled', ouverture: 'relaunched', reprise: 'first listening' },
    cadence: { libelle: 'Automatic listening', aucune: 'No automatic listening', quotidienne: 'Every day', hebdo: 'Every week', mensuelle: 'Every month' },
    terrain: {
      titre: 'What our twins report from the field',
      provenance: 'Twins’ field',
      ou: 'Mostly in: {ou}',
      avis: 'Opinions: {avis}',
    },
  },
  resultat: {
    regarderaient: 'would watch it',
    regarderaientCibles: 'would watch it, on your targets',
    aucuneDevant: 'No version stands out',
    lEmporte: '“{nom}” wins',
    devanceDePeu: '“{nom}” is narrowly ahead',
    jusquAuBout: 'watch to the end',
    partProjetee: 'projected audience share',
    partSimulee: 'simulated audience share',
    premiereSemaine: 'would watch it in its first week',
    sortieLe: 'On {plateforme} on {jour}',
    personnes: '{valeur} people{bornes}',
    export: 'Format {verdict}',
    detail: 'Details',
    luLe: 'read on {jour}',
    indifferents: '{pct} indifferent',
    rang: '{rang} of {sur} against its comparables, read blind',
    projectionClasse: 'Projection from the class: {pda} audience share{bornes}.',
    surCibles: 'Would watch, on your targets: {cibles}',
    surEnsemble: 'Would watch, across the whole panel',
    choisissentCibles: 'Seen side by side, the share picking each version, on your targets: {cibles}',
    choisissentEnsemble: 'Seen side by side, the share picking each version, across the whole panel',
    telespectateurs: '{valeur} viewers{bornes}',
    rienALire: 'Nothing readable in this result.',
    aussiSur: 'Also read on: {cibles}. The detail is on the test page.',
    partiel: 'Partial result: one version did not respond.',
  },
  format: {
    titreAttente: 'Format',
    sousTitre: 'Steps tested: {n} of {sur}',
    ariane: 'Breadcrumb',
    introuvable: 'This format cannot be found.',
    retourListe: 'Back to formats',
    brief: 'The brief',
    cibles: 'Targets: {cibles}',
    adapteDe: 'Adapted from: {pays}',
    premiereLe: 'First broadcast on {jour}',
    premiereARenseigner: 'First broadcast date missing',
    partage: {
      prive: 'visible to its author only',
      equipe: 'shared with the team',
      personnes: 'shared with {n} people | shared with {n} person | shared with {n} people',
      choisies: 'shared with selected people',
    },
    modifierBrief: 'Edit the brief',
    escalierDe: 'The ladder of {titre}',
    etNouvelleLecture: '{resultat} · a new reading in progress',
    enCours: 'In progress',
    manqueSoiree: 'The first broadcast date or the slot is missing.',
    manqueSortie: 'The release date is missing.',
    completerBrief: 'Complete the brief',
    voirLesTests: 'See the {n} tests | See the test | See the {n} tests',
    derniersResultats: 'Latest results',
  },
  // A format's documents and listening, moved from the Overview tabs to the sidebar (10 October 2026).
  marche_page: {
    sousTitre: '{titre} · {n} tests | {titre} · {n} test | {titre} · {n} tests',
    rend: 'What this step delivers: {sortie}.',
    tableau: 'The tests of this step',
    aucun: 'No test on this step yet.',
    sansResultat: 'No result yet',
    col: { test: 'Test', resultat: 'Result', etat: 'Status', quand: 'By, on' },
  },
  section: {
    documents: { titre: 'Documents', sousTitre: 'The documents uploaded for {titre}' },
    ecoute: { titre: 'Listening', sousTitre: 'What is being said about {titre} since it aired' },
    suivi: { titre: 'On air', sousTitre: '{titre} on air, broadcast by broadcast' },
  },
  genre: { prime: 'Prime time', quotidienne: 'Daily', autre: 'Other slot' },
  jours: { tous: 'every day', seul: '{jour}', plage: '{de} to {a}', aHeure: '{jours} at {heure}', et: 'and' },
  suivi: {
    panneau: '{titre} on air',
    aide: 'Every broadcast of its slots on {chaine} and its ratings, collected the next morning.',
    aideSansChaine: 'Every broadcast of its slots and its ratings, collected the next morning.',
    pasALAntenne: 'This format is not tracked on air. In its brief, tick “Already on air” on its channel and pick its slots.',
    erreur: 'The tracking could not be read.',
    modifier: 'Its slots',
    relever: 'Collect now',
    releveEnCours: 'Collecting ratings',
    prochain: 'Next broadcast',
    dernier: 'Last broadcast',
    evolution: 'Versus the previous one',
    face: 'versus {quand} ({telespectateurs})',
    unSeul: 'Two measured broadcasts are needed.',
    moyenne: 'Average of the last {n}',
    moyenneSans: 'Average',
    telespectateursPart: 'viewers, {pda} share',
    points: '{v} pt share',
    barresAria: 'Ratings of {titre}, {n} broadcasts, in millions of viewers',
    enMillions: 'In millions of viewers aged 4 and over.',
    passes: 'Broadcasts',
    aVenir: 'Coming up',
    aucunPassage: 'No broadcast of this slot in the last eight weeks.',
    attendue: 'Ratings published tomorrow morning',
    enAttente: 'Ratings to collect',
    introuvable: 'Ratings not published yet',
    article: 'Article',
    col: { quand: 'Broadcast', telespectateurs: 'Viewers', pda: 'Share', cibles: 'Targets', source: 'Source', lecture: 'Reading' },
    lecture: 'Read',
    voirLecture: 'See the reading',
    masquerLecture: 'Hide the reading',
    projeter: 'Project this broadcast',
    projection: {
      tete: 'Orion projection: {part}',
      rejouee: 'Replayed after the broadcast: {part}',
      part: '{pct} ({bas} ~ {haut}%)',
      telespectateurs: '{n} viewers',
      mesure: 'measured {pda}, gap {ecart}',
      seconde: 'Part 2: {part}',
      voirTest: 'Open the test',
      scellee: 'Sealed on {quand}',
      voirEnveloppe: 'Open the envelope',
      auto: 'Day-before projection',
      jumeaux: 'Twins alone: {pct}',
      concurrents: 'The other channels, projected',
    },
    auto: {
      titre: 'Project each broadcast the day before',
      aide: 'Each broadcast is projected the day before from 2 pm and sealed before it airs; its measurement is set against it the next day.',
      active: 'Turned on by {qui}',
      activer: 'Turn on',
      couper: 'Turn off',
    },
  },
  lecture: {
    titre: 'Why: {passage}',
    aide: 'What was said before, during and after the broadcast, the evening’s competition, and what you can test next.',
    erreur: 'The reading could not be loaded.',
    enCours: 'Reading in progress: what was said, then why. A few minutes.',
    echec: 'The reading of this broadcast failed.',
    pasEncore: 'This broadcast has not been read yet.',
    pasDiffuse: 'This broadcast has not aired yet.',
    lire: 'Read this broadcast',
    relire: 'Read again',
    fermer: 'Close',
    pourquoi: 'Why',
    force: { forte: 'strong reason', moyenne: 'medium reason', faible: 'weak reason' },
    detail: 'See details',
    masquer: 'Hide',
    ceQuiSestDit: 'What was said',
    courbeAria: 'The conversation on X, hour by hour: {avant} messages before, {pendant} during, {apres} after',
    pic: 'peak at {heure}: {n} messages',
    fenetre: { avant: 'Before', pendant: 'During', apres: 'After' },
    surX: '{n} on X',
    ton: '{favorable} positive, {defavorable} negative',
    intention: { regarde_aime: 'watches and likes it', regarde_deteste: 'watches while complaining', decroche: 'drops off', indifferent: 'no view' },
    rienLu: 'Nothing read in this window.',
    moments: 'What got people talking',
    concurrence: 'The competition that evening',
    pistes: 'To test next',
    genre: { sonar: 'Sonar', ab: 'A/B' },
    question: 'The question:',
    preparer: { sonar: 'Prepare this Sonar', ab: 'Prepare this A/B' },
    lancee: { a_lancer: 'Prepared {quand}, not launched yet', en_cours: 'Launched {quand}, running', pret: 'Results ready', echec: 'Failed' },
    voir: { sonar: 'Open the Sonar', ab: 'Open the test' },
    repreparer: 'Prepare again',
    personas: 'Who talked about it',
    origine: 'people who talked about {passage}',
  },
}
